export default "__VITE_ASSET__Bn6k0FN0__"